import { css } from 'styled-components';
import token from 'styled-token';
import { StyledImage } from '../../components/Image/Image.styles';
import { StyledPropertyCardPhotoFallback } from '../../components/PropertyCardPhotoFallback/PropertyCardPhotoFallback.styles';
import { PHOTO_ORIENTATIONS, PROPERTY_CARD_APPEARANCES } from '../../constants';
var fallbackImageCSS = function fallbackImageCSS(props) {
  var appearance = props.appearance;
  return token({
    fill: 'PropertyCard.fallbackImage.fill',
    size: "PropertyCard.fallbackImage.size." + appearance
  }, function (_ref) {
    var fill = _ref.fill,
      size = _ref.size;
    return css(["", "{height:", "px;width:", "px;position:absolute;left:50%;top:50%;transform:translate3d(-50%,-50%,0);.Fallback__fill{fill:", ";}}"], StyledPropertyCardPhotoFallback, size, size, fill);
  })(props);
};
var portraitBackgroundCSS = function portraitBackgroundCSS(props) {
  var photoOrientation = props.photoOrientation,
    photoSrc = props.photoSrc;
  if (photoOrientation !== PHOTO_ORIENTATIONS.PORTRAIT) {
    return '';
  }

  /* To help portrait photos fill up their container, add a
    blurred version in the background. */
  return token({
    backgroundColor: 'PropertyCard.photo.backgroundColor',
    blur: "PropertyCard.photo.backgroundBlur"
  }, function (_ref2) {
    var backgroundColor = _ref2.backgroundColor,
      blur = _ref2.blur;
    return css(["&:after{background:url(", ") no-repeat ", ";background-size:cover;content:'';display:block;filter:blur(", "px);position:absolute;top:0;right:0;bottom:0;left:0;z-index:-1;}", "{object-fit:contain;}"], photoSrc, backgroundColor, blur, StyledImage);
  })(props);
};

/** @class PropertyCardPhotoMixin */
/** @method */
export var PropertyCardPhotoMixin = function PropertyCardPhotoMixin(props) {
  return token({
    backgroundColor: 'PropertyCard.photo.backgroundColor',
    borderRadius: 'PropertyCard.cardBody.borderRadius'
  }, function (_ref3) {
    var backgroundColor = _ref3.backgroundColor,
      borderRadius = _ref3.borderRadius;
    var isVerticalCard = props.appearance === PROPERTY_CARD_APPEARANCES.LARGE || props.appearance === PROPERTY_CARD_APPEARANCES.SMALL;
    return css(["border-top-left-radius:", "px;border-top-right-radius:", "px;border-bottom-right-radius:0;border-bottom-left-radius:", "px;height:100%;overflow:hidden;position:relative;z-index:0;background-color:", ";", "{object-fit:cover;width:100%;height:0;min-height:100%;}", " ", ""], borderRadius, isVerticalCard ? borderRadius : 0, isVerticalCard ? 0 : borderRadius, backgroundColor, StyledImage, fallbackImageCSS(props), portraitBackgroundCSS(props));
  })(props);
};